/**
 * The shared card treatment for the landing page's dark sections (TheProblem, WhyNotChatGpt):
 * at rest the card is the section's own colour with a faint white outline and white text;
 * on hover it turns white and its contents switch to the light-theme colours. Kept in one
 * place so every dark card behaves the same way.
 *
 * The card itself needs `group` (included in `darkCard`); the other classes key off it.
 */

export const darkCard =
  "group rounded-xl border border-white/15 bg-transparent transition-colors duration-300 hover:border-white hover:bg-white";

export const darkCardTitle =
  "text-white transition-colors duration-300 group-hover:text-mkt-inarax-black";

export const darkCardBody =
  "text-white transition-colors duration-300 group-hover:text-mkt-on-surface-variant";

/** Small uppercase label, e.g. "Generic LLM" / "inaraX". */
export const darkCardLabel =
  "text-white transition-colors duration-300 group-hover:text-mkt-primary";

/** Round icon badge. */
export const darkCardIcon =
  "bg-white/10 text-white ring-1 ring-white/25 transition-colors duration-300 group-hover:bg-mkt-primary/10 group-hover:text-mkt-primary group-hover:ring-mkt-primary/30";
